export default __webpack_public_path__ + "static/media/LocalCryptos.1a808aad.png";